import React from 'react';
import Message from './Message';

export default function ChatMessages({ scrollRef, messages, selectMcqOption }) {
  return (
    <div className="flex w-full flex-col items-stretch justify-start px-0 py-2">
      {messages.map((msg) => (
        <Message
          key={msg.id}
          id={msg.id}
          isSentByUser={msg.isSentByUser}
          message={msg.message}
          photoURL={msg.photoURL}
          displayName={msg.displayName}
          selectMcqOption={selectMcqOption}
        />
      ))}
      <div ref={scrollRef} className="h-px shrink-0" aria-hidden />
    </div>
  );
}
